import React from 'react'

import { css } from 'design'
import { cn } from 'util/cn'

const tag = css({
  $$color: '$colors$grey900',
  $$backgroundColor: '$colors$grey100',
  $$backgroundOpacity: 1,
  position: 'relative',
  display: 'inline-flex',
  flex: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '$0',
  lineHeight: 1.2,
  color: '$$color',
  borderRadius: 3,
  padding: '2px $1',
  zIndex: 0,
  '&::before': {
    content: '""',
    position: 'absolute',
    width: '100%',
    height: '100%',
    borderRadius: 3,
    backgroundColor: '$$backgroundColor',
    zIndex: -1,
  },
  '.topic__theme--dark &': {
    '&::before': {
      opacity: '$$backgroundOpacity',
    },
  },
  variants: {
    variant: {
      default: {
        $$color: '$colors$grey900',
        $$backgroundColor: '$colors$grey100',
      },
      clean: {
        $$backgroundColor: 'transparent',
      },
      danger: {
        $$color: '$colors$dangerHigh',
        $$backgroundColor: '$colors$dangerLow',
        $$backgroundOpacity: 0.2,
      },
      warning: {
        $$color: '$colors$warningHigh',
        $$backgroundColor: '$colors$warningLow',
        $$backgroundOpacity: 0.2,
      },
      success: {
        $$color: '$colors$successHigh',
        $$backgroundColor: '$colors$successLow',
        $$backgroundOpacity: 0.2,
      },
      info: {
        $$color: '$colors$infoHigh',
        $$backgroundColor: '$colors$infoLow',
        $$backgroundOpacity: 0.2,
      },
    },
  },
})

export type TagProps = {
  variant?: 'default' | 'danger' | 'warning' | 'success' | 'info' | 'clean'
} & React.HTMLAttributes<HTMLDivElement>

export const Tag = React.forwardRef<HTMLDivElement, TagProps>(
  ({ variant = 'default', children, className, ...props }, ref) => {
    return (
      <div
        className={cn(
          tag({ variant }),
          className ? className : '',
        )}
        ref={ref}
        {...props}
      >
        {children}
      </div>
    )
  },
)

Tag.displayName = 'Tag'
